export default {
  name: "DialogCustomView",
  data() {
    return {
      dialogVisible: false
    };
  },
  props: {
    visibleControl: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '40%'
    },
    title: {
      type: String,
      default: '40%'
    }
  },
  watch: {
    visibleControl(b) {
      this.dialogVisible = b;
    }
  },
  methods: {
    onDialogClose() {
      this.dialogVisible = false;
      this.$emit('onDialogClose');
      this.$emit('close');
    }
  }
};